module.exports = "/_next/static/images/sadBoyImage-96672ee09e1f4b74e5fce56c92baa9e6.png";